import {downloadInvoice} from '../invoice-download.js'
import {request} from '@/http/http.js'

// get isp proxy list /api/staticip/list
export function getStaticIpList(query) {
  return request({
    url: '/api/staticip/list',
    method: 'get',
    params: query
  })
}

// export static house order ips
export function exportStaticIps(query) {
  return request({
    url: '/api/staticip/export',
    method: 'post',
    responseType: 'arraybuffer',
    data: query,
    headers: {
      'Content-Type': 'application/json',
    }
  })
}

// export static house order ips
export function extractOrderProxyAccounts(query) {
  return request({
    url: '/api/staticip/orderAccounts',
    method: 'post',
    data: query,
    headers: {
      'Content-Type': 'application/json',
    }
  })
}


export function extractProxyAccounts(query) {
  return request({
    url: '/api/staticip/accounts',
    method: 'post',
    data: query,
    headers: {
      'Content-Type': 'application/json',
    }
  })
}

export function tagIps(query) {
  return request({
    url: '/api/staticip/tag',
    method: 'post',
    data: query,
    headers: {
      'Content-Type': 'application/json',
    }
  })
}

// export order invoce
export function exportInvoice(query) {
  return downloadInvoice('/api/invoice/export', query)
}

// 订单列表 /api/order/index
export function getOrderList(query) {
  return request({
    url: '/api/order/history',
    method: 'get',
    params: query
  })
}
// 订单详情 /api/order/info
export function getOrderInfo(query) {
  return request({
    url: '/api/order/info',
    method: 'get',
    params:query
  })
}

//预下单 /api/order/prepare_renew
export function prepareRenewOrder(query) {
  return request({
    url: '/api/order/prepare_renew',
    method: 'post',
    data: query,
    headers: {
      'Content-Type': 'application/json',
    }
  })
}

//预下单 /api/order/prepare
export function prepareOrder(query) {
  return request({
    url: '/api/order/prepare',
    method: 'post',
    data: query,
    headers: {
      'Content-Type': 'application/json',
    }
  })
}

// 创建订单 /api/order/create
export function createOrder(query) {
  return request({
    url: '/api/order/create',
    method: 'post',
    data: query,
    headers: {
      'Content-Type': 'application/json',
    }
  })
}
// * 续费订单 /api/order/renew
export function renewOrder(query) {
  return request({
    url: '/api/order/renew',
    method: 'post',
    data: query,
    headers: {
      'Content-Type': 'application/json',
    }
  })
}

// * 续费订单 /api/order/cancel
export function cancelOrder(query) {
  return request({
    url: '/api/order/cancel',
    method: 'post',
    data: query,
    headers: {
      'Content-Type': 'application/json',
    }
  })
}

 // stripe支付 /api/payment/stripe_pay
 export function stripePay(query) {
   return request({
     url: '/api/payment/create',
     method: 'post',
     data: query,
     headers: {
      'Content-Type': 'application/json',
    }
   })
 }

// 检查订单支付结果 /api/order/status
export function getOrderStatus(query) {
  return request({
    url: '/api/order/status',
    method: 'get',
    params: query
  })
}

// 余额支付
export function initCheckout(query) {
  return request({
    url: '/api/checkout/init',
    method: 'get',
    params: query
  })
}

export function applyCoupon(params) {
  return request({
    url: '/api/checkout/applyCoupon',
    method: 'post',
    data: params,
    headers: {
     'Content-Type': 'application/json',
   }
  })
}

export function checkoutPay(params) {
  return request({
    url: '/api/checkout/pay',
    method: 'post',
    data: params,
    headers: {
     'Content-Type': 'application/json',
   }
  })
}
